export const stockMovement = {
  transferrerDiffs: {
    transferrer_provider_id: {
      type: 'поставщик',
      field: 'name',
    },
    transferrer_user_id: {
      type: 'сотрудник',
      field: 'login',
    },
  },
  entities: {
    all: "Все",
    products: "Продукты",
    cut_of_clothes: "Крой",
    cloths: "Ткани",
    sewing_accessories: "Фурнитура",
    stationery: "Канцелярия",
    expendable_materials: "Расходники",
    promotional_products: "Рекламная продукция",
    packages: "Упаковка",
  },
  operationTypes: {
    arrivals: "Приходы",
    expenses: "Расходы",
    write_offs: "Списания",
    transfer: "Передачи",
  },
  tables: {
    cloth_id: "cloths",
    sewing_accessory_id: "sewing_accessories",
    stationery_id: "stationery",
    expendable_material_id: "expendable_materials",
    promotional_product_id: "promotional_products",
    package_id: "packages",
    product_id: "products",
    cut_of_clothes_id: "cut_of_clothes",
  },
  entity: {
    byForeignKey: {
      sewing_accessory_id: "фурнитура",
      cloth_id: "ткань",
      stationery_id: "канцелярия",
      expendable_material_id: "расходник",
      promotional_product_id: "рекламная продукция",
      package_id: "упаковка",
      product_id: "продукт",
      cut_of_clothes_id: "крой",
    },
    byTable: {
      sewing_accessories: "фурнитура",
      cloths: "ткань",
      stationery: "канцелярия",
      expendable_materials: "расходник",
      promotional_products: "рекламная продукция",
      packages: "упаковка",
      products: "продукт",
      cut_of_clothes: "крой",
    },
  },
};



// WEBPACK FOOTER //
// ./src/stock/constants/stockMovement.js